// CTSK-312 Slice 1 (ADR 0002 §3.1) — shared Zod shape for a nest-scoped
// integration template. Mirrors the `nest_integration_templates` table
// (apps/api/src/db/schema.ts) field-for-field (camelCase here, snake_case
// in SQL). This is the AUTHORING shape a bundle's `nestIntegrations:`
// block declares — the bundle-importer path that validates against it
// and materializes rows lands in Slice 2 (out of scope this slice; see
// ADR §4 slice list). Not wired into BundleSchema yet.
//
// `handle` is deliberately unqualified and forbids `/` (ADR §3 Q3): the
// `<nest-slug>/` prefix is applied at resolution + display time, never
// stored. Reserving `/` out of this regex is what keeps
// `computeEffectivePatScopes`'s routing (slash → nest-template lookup,
// no slash → global ROLE_CATALOG) unambiguous.
import { z } from 'zod';
export const NestIntegrationTemplateSchema = z.object({
    handle: z.string().min(1).max(64).regex(/^[a-z0-9][a-z0-9-]*$/, 'handle must be lowercase letters, digits and hyphens (no "/" — namespacing is applied, not stored)'),
    // §6.1 gate 1 — every template needs a charter paragraph. NOT NULL at
    // the DB layer too (schema.ts); enforced here as well so a bundle
    // author gets the validation error before import, not a DB constraint
    // violation.
    description: z.string().min(1),
    capabilities: z.array(z.string().min(1)),
    category: z.string().min(1).max(32),
    version: z.string().min(1).max(32),
    // §6.1 gate 2 — every template needs a ticket reference.
    ticketRef: z.string().min(1).max(32),
    deprecated: z.boolean().optional().default(false),
    replacedBy: z.string().max(128).nullable().optional(),
});
//# sourceMappingURL=nest-integration-template.js.map